'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Typography = require('../../../../../../common/components/Typography.js');
var Chip = require('../../../../../../common/components/Chip.js');
var index = require('../../../../../../common/theme/index.js');
var TrackingStatusText = require('../../../../../../common/components/TrackingStatusText.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const narvarStatusColors = {
  DELIVERED: index.colors.statusSuccessLight,
  INTRANSIT: index.colors.statusWarnLight,
  JUSTSHIPPED: index.colors.statusWarnLight,
  EXCEPTION: index.colors.statusDangerLight,
  BOPISCANCELED: index.colors.statusDangerLight,
  BOPISDELAYED: index.colors.statusDangerLight,
  BOPISPICKEDUP: index.colors.statusSuccessLight,
  BOPISPROCESSING: index.colors.statusWarnLight,
  BOPISREADYFORPICKUP: index.colors.statusWarnLight,
  HPUEXCEPTION: index.colors.statusIndeterminateLight,
  HPUPICKEDUP: index.colors.statusIndeterminateLight,
  HPUPICKUPINPROGRESS: index.colors.statusIndeterminateLight,
  HPUSCHEDULED: index.colors.statusIndeterminateLight,
  LDDELIVERED: index.colors.statusSuccessLight,
  LDEXCEPTION: index.colors.statusDangerLight,
  LDONITSWAY: index.colors.statusWarnLight,
  LDORDERPLACED: index.colors.statusWarnLight,
  LDPICKUPINPROGRESS: index.colors.statusWarnLight,
  PRESHIPMENT0: index.colors.statusWarnLight,
  PRESHIPMENT1: index.colors.statusWarnLight,
  PRESHIPMENT2: index.colors.statusWarnLight,
  PRESHIPMENT3: index.colors.statusWarnLight,
  PRESHIPMENT4: index.colors.statusWarnLight,
  PRESHIPMENT5: index.colors.statusWarnLight,
  PRESHIPMENT6: index.colors.statusWarnLight,
  PRESHIPMENT7: index.colors.statusWarnLight,
  PRESHIPMENT8: index.colors.statusWarnLight,
  PRESHIPMENT9: index.colors.statusWarnLight,
  PROCESSING: index.colors.statusWarnLight
};
const NarvarStatusChip = _ref => {
  let {
    status,
    statusCode
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(Chip["default"], {
    as: "div",
    style: {
      background: narvarStatusColors[status],
      border: narvarStatusColors[status],
      justifySelf: 'start'
    }
  }, /*#__PURE__*/React__default["default"].createElement(Typography.MetadataTextEmphasis, null, /*#__PURE__*/React__default["default"].createElement(TrackingStatusText["default"], {
    status: status,
    statusCode: statusCode
  })));
};

exports["default"] = NarvarStatusChip;
